export default __webpack_public_path__ + "static/media/JoaoSantos.12f64904.png";